(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-principal"] && !Shopify.designMode) return;
  try {
    
const initCarruselFlux = () => {
  const sliders = document.querySelectorAll('.carrusel-flux-contenedor');
  
  sliders.forEach(slider => {
    if(slider.dataset.inicializado === 'true') return;
    slider.dataset.inicializado = 'true';

    const pista = slider.querySelector('.carrusel-flux-pista');
    const slides = slider.querySelectorAll('.carrusel-flux-slide');
    const btnPrev = slider.querySelector('.carrusel-flux-prev');
    const btnNext = slider.querySelector('.carrusel-flux-next');
    const puntos = slider.querySelectorAll('.carrusel-flux-punto');
    
    if (slides.length > 1) {
      let indexActual = 0;
      let animando = false;
      let intervaloAuto;
      
      const esAutoplay = slider.getAttribute('data-autoplay') === 'true';
      const velocidadAuto = parseInt(slider.getAttribute('data-velocidad')) || 5000;
      let startX = 0;
      let presionado = false;
      let isDragging = false;

      const actualizarCarrusel = (nuevoIndex) => {
        if (animando) return;
        animando = true;
        
        if (nuevoIndex < 0) nuevoIndex = slides.length - 1;
        if (nuevoIndex >= slides.length) nuevoIndex = 0;
        
        indexActual = nuevoIndex;
        pista.style.transform = `translateX(-${indexActual * 100}%)`;
        
        puntos.forEach(pto => pto.classList.remove('carrusel-flux-punto-activo'));
        if(puntos[indexActual]) puntos[indexActual].classList.add('carrusel-flux-punto-activo');
        
        setTimeout(() => { animando = false; }, 600);
      };

      const iniciarAutoplay = () => {
        if (esAutoplay) {
          clearInterval(intervaloAuto);
          intervaloAuto = setInterval(() => actualizarCarrusel(indexActual + 1), velocidadAuto);
        }
      };

      const detenerAutoplay = () => {
        if (esAutoplay) clearInterval(intervaloAuto);
      };

      if (btnPrev) btnPrev.addEventListener('click', () => { actualizarCarrusel(indexActual - 1); iniciarAutoplay(); });
      if (btnNext) btnNext.addEventListener('click', () => { actualizarCarrusel(indexActual + 1); iniciarAutoplay(); });
      
      puntos.forEach((pto, i) => {
        pto.addEventListener('click', () => { actualizarCarrusel(i); iniciarAutoplay(); });
      });

      const handleDragStart = (clientX) => {
        startX = clientX;
        presionado = true;
        isDragging = false;
        detenerAutoplay();
      };

      const handleDragMove = (clientX) => {
        if (!presionado) return;
        const diferencia = startX - clientX;
        if (Math.abs(diferencia) > 15) {
          isDragging = true;
        }
      };

      const handleDragEnd = (clientX) => {
        if (!presionado) return;
        presionado = false;
        const diferencia = startX - clientX;
        
        if (Math.abs(diferencia) > 40) {
          if (diferencia > 0) actualizarCarrusel(indexActual + 1);
          else actualizarCarrusel(indexActual - 1);
        }
        iniciarAutoplay();
      };

      pista.addEventListener('mousedown', (e) => handleDragStart(e.clientX));
      pista.addEventListener('mousemove', (e) => handleDragMove(e.clientX));
      pista.addEventListener('mouseup', (e) => handleDragEnd(e.clientX));
      pista.addEventListener('mouseleave', (e) => { if(presionado) handleDragEnd(e.clientX); });

      pista.addEventListener('touchstart', (e) => handleDragStart(e.touches[0].clientX), { passive: true });
      pista.addEventListener('touchmove', (e) => handleDragMove(e.touches[0].clientX), { passive: true });
      pista.addEventListener('touchend', (e) => handleDragEnd(e.changedTouches[0].clientX), { passive: true });

      pista.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      slider.addEventListener('mouseenter', detenerAutoplay);
      slider.addEventListener('mouseleave', iniciarAutoplay);

      iniciarAutoplay();
    }
  });

  const relojes = document.querySelectorAll('.carrusel-flux-reloj');
  relojes.forEach(reloj => {
    if(reloj.intervaloID) clearInterval(reloj.intervaloID);

    const fecha = reloj.getAttribute('data-fecha');
    const hora = reloj.getAttribute('data-hora') || '00:00';
    const msjFin = reloj.getAttribute('data-mensaje');
    
    if (!fecha) return;

    const targetString = `${fecha} ${hora}:00 GMT-0600`;
    const targetDate = new Date(targetString).getTime();
    const perimetro = 282.74;

    const contDias = reloj.querySelector('[data-valor="dias"]');
    const contHoras = reloj.querySelector('[data-valor="horas"]');
    const contMins = reloj.querySelector('[data-valor="mins"]');
    const contSegs = reloj.querySelector('[data-valor="segs"]');

    const svgDias = reloj.querySelector('[data-tipo="dias"]');
    const svgHoras = reloj.querySelector('[data-tipo="horas"]');
    const svgMins = reloj.querySelector('[data-tipo="mins"]');
    const svgSegs = reloj.querySelector('[data-tipo="segs"]');

    const actualizarReloj = () => {
      const ahora = new Date().getTime();
      const diferencia = targetDate - ahora;

      if (diferencia <= 0) {
        reloj.innerHTML = `<div class="carrusel-flux-msj-fin">${msjFin}</div>`;
        clearInterval(reloj.intervaloID);
        return;
      }

      const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
      const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);

      if(contDias) contDias.textContent = dias < 10 ? '0' + dias : dias;
      if(contHoras) contHoras.textContent = horas < 10 ? '0' + horas : horas;
      if(contMins) contMins.textContent = minutos < 10 ? '0' + minutos : minutos;
      if(contSegs) contSegs.textContent = segundos < 10 ? '0' + segundos : segundos;

      if(svgDias) svgDias.style.strokeDashoffset = perimetro - (perimetro * (dias > 30 ? 30 : dias) / 30);
      if(svgHoras) svgHoras.style.strokeDashoffset = perimetro - (perimetro * horas / 24);
      if(svgMins) svgMins.style.strokeDashoffset = perimetro - (perimetro * minutos / 60);
      if(svgSegs) svgSegs.style.strokeDashoffset = perimetro - (perimetro * segundos / 60);
    };

    actualizarReloj();
    reloj.intervaloID = setInterval(actualizarReloj, 1000);
  });
};

document.addEventListener('DOMContentLoaded', initCarruselFlux);
if (window.Shopify && Shopify.DesignMode) {
  document.addEventListener('shopify:section:load', initCarruselFlux);
}
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(initCarruselFlux, 100);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galeria-deslizable"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function inicializarCarruselesBanner() {
      const carruseles = document.querySelectorAll('.seccion-banner-carrusel');
      
      carruseles.forEach(carrusel => {
        const puntos = carrusel.parentElement.querySelectorAll('.seccion-banner-punto');
        const diapositivas = carrusel.querySelectorAll('.seccion-banner-diapositiva');
        let presionado = false;
        let inicioX;
        let scrollIzquierdo;

        carrusel.addEventListener('mousedown', (e) => {
          presionado = true;
          inicioX = e.pageX - carrusel.offsetLeft;
          scrollIzquierdo = carrusel.scrollLeft;
          carrusel.style.scrollSnapType = 'none';
        });

        carrusel.addEventListener('mouseleave', () => {
          presionado = false;
          carrusel.style.scrollSnapType = 'x mandatory';
        });

        carrusel.addEventListener('mouseup', () => {
          presionado = false;
          carrusel.style.scrollSnapType = 'x mandatory';
        });

        carrusel.addEventListener('mousemove', (e) => {
          if (!presionado) return;
          e.preventDefault();
          const x = e.pageX - carrusel.offsetLeft;
          const recorrido = (x - inicioX) * 2;
          carrusel.scrollLeft = scrollIzquierdo - recorrido;
        });

        carrusel.addEventListener('scroll', () => {
          const indiceActual = Math.round(carrusel.scrollLeft / carrusel.offsetWidth);
          puntos.forEach((punto, i) => {
            if(i === indiceActual) {
              punto.classList.add('activo');
            } else {
              punto.classList.remove('activo');
            }
          });
        });

        puntos.forEach((punto, index) => {
          punto.addEventListener('click', () => {
            const posicionDestino = diapositivas[index].offsetLeft;
            carrusel.scrollTo({
              left: posicionDestino,
              behavior: 'smooth'
            });
          });
        });
      });
    }

    document.addEventListener('DOMContentLoaded', inicializarCarruselesBanner);

    if (window.Shopify && Shopify.DesignMode) {
      document.addEventListener('shopify:section:load', inicializarCarruselesBanner);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconos-texto"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarDeslizadores() {
    const deslizadores = document.querySelectorAll('.seccion-iconos-texto-movil-deslizador');
    
    deslizadores.forEach(function(deslizador) {
      if (window.innerWidth >= 749) return;
      
      const contenedor = deslizador.closest('.seccion-iconos-texto-contenedor');
      const puntosContenedor = contenedor.querySelector('.seccion-iconos-texto-controles');
      
      if (!puntosContenedor) return;
      
      const puntos = puntosContenedor.querySelectorAll('.seccion-iconos-texto-punto');
      
      deslizador.addEventListener('scroll', function() {
        const anchoElemento = deslizador.offsetWidth;
        const posicionScroll = deslizador.scrollLeft;
        let indiceActual = Math.round(posicionScroll / anchoElemento);
        
        puntos.forEach(function(punto) {
          punto.classList.remove('activo');
        });
        
        if (puntos[indiceActual]) {
          puntos[indiceActual].classList.add('activo');
        }
      });
      
      puntos.forEach(function(punto, indice) {
        punto.addEventListener('click', function() {
          const anchoElemento = deslizador.offsetWidth;
          deslizador.scrollTo({
            left: anchoElemento * indice,
            behavior: 'smooth'
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', inicializarDeslizadores);
  
  if (window.Shopify && Shopify.DesignMode) {
    document.addEventListener('shopify:section:load', inicializarDeslizadores);
    window.addEventListener('resize', inicializarDeslizadores);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-barra-anuncios"] && !Shopify.designMode) return;
  try {
    
(function() {
  function inicializarSbaBarra() {
    const barras = document.querySelectorAll('.sba-barra');
    barras.forEach(barra => {
      const activarContador = barra.dataset.activarContador === 'true';
      const fechaFinalizacionStr = barra.dataset.fechaFinalizacion;
      const activarTextoRotativo = barra.dataset.textoRotativo === 'true';
      const intervaloRotacion = parseInt(barra.dataset.intervaloRotacion) * 1000;

      if (activarContador && fechaFinalizacionStr) {
        const contadorHorasVal = barra.querySelector('.sba-barra__contador-horas .sba-barra__contador-valor');
        const contadorMinutosVal = barra.querySelector('.sba-barra__contador-minutos .sba-barra__contador-valor');
        const contadorSegundosVal = barra.querySelector('.sba-barra__contador-segundos .sba-barra__contador-valor');

        const fechaFinalizacionGmt = new Date(fechaFinalizacionStr.replace(' ', 'T') + '-06:00').getTime();

        const actualizarContador = () => {
          const ahoraGmt = new Date().getTime();
          const diferencia = fechaFinalizacionGmt - ahoraGmt;

          if (diferencia <= 0) {
            const contDom = barra.querySelector('.sba-barra__contador');
            if (contDom) contDom.style.display = 'none !important';
            return;
          }

          const horas = Math.floor(diferencia / (1000 * 60 * 60));
          const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
          const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);

          if (contadorHorasVal) contadorHorasVal.textContent = String(horas).padStart(2, '0');
          if (contadorMinutosVal) contadorMinutosVal.textContent = String(minutos).padStart(2, '0');
          if (contadorSegundosVal) contadorSegundosVal.textContent = String(segundos).padStart(2, '0');
        };

        actualizarContador();
        setInterval(actualizarContador, 1000);
      }

      const bloquesTexto = barra.querySelectorAll('.sba-barra__texto-bloque');
      if (bloquesTexto.length > 0) {
        bloquesTexto.forEach(b => b.classList.remove('activo'));
        bloquesTexto[0].classList.add('activo');

        if (activarTextoRotativo && bloquesTexto.length > 1) {
          let indiceActual = 0;
          if (barra.dataset.intervaloId) {
            clearInterval(parseInt(barra.dataset.intervaloId));
          }
          const intId = setInterval(() => {
            bloquesTexto[indiceActual].classList.remove('activo');
            indiceActual = (indiceActual + 1) % bloquesTexto.length;
            bloquesTexto[indiceActual].classList.add('activo');
          }, intervaloRotacion);
          barra.dataset.intervaloId = intId;
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', inicializarSbaBarra);
  if (window.Shopify && Shopify.DesignMode) {
    document.addEventListener('shopify:section:load', inicializarSbaBarra);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
